import React from 'react';
import { HiOutlineHome } from 'react-icons/hi';
import { MdFlight } from 'react-icons/md';

const HomeAwayRevealSection = () => {
  // Home features
  const homeFeatures = [
    { text: 'Works on cellular iPad or dual eSIM device', icon: '/assets/images/homeaway/home/ipad-dual.svg' },
    { text: 'No contract extra data eSIM provider', icon: '/assets/images/homeaway/home/contract.svg' },
    { text: 'Have a back up provider', icon: '/assets/images/homeaway/home/backup.svg' },
    { text: 'Overage protection', icon: '/assets/images/homeaway/home/overage.svg' },
    { text: 'Private, alternate data connection', icon: '/assets/images/homeaway/home/private.svg' }
  ];

  // Away features
  const awayFeatures = [
    { text: 'Automatic connection to the best local network', icon: '/assets/images/homeaway/away/automatic-network.svg' },
    { text: 'Tier one carrier access', icon: '/assets/images/homeaway/away/tier1.svg' },
    { text: 'Different countries, one eSIM', icon: '/assets/images/homeaway/away/different.svg' },
    { text: 'No Roaming shock', icon: '/assets/images/homeaway/away/shock.svg' },
    { text: 'Long term, set it and forget it', icon: '/assets/images/homeaway/away/long-term.svg' }
  ];

  const tealColor = '#49a078';

  return (
    <div className="py-16 bg-gray-50 dark:bg-gray-800 transition-colors duration-200">
      <div className="container mx-auto px-4 md:px-8">
        {/* Section Header */}
        <h2 className="text-3xl font-bold text-center mb-4 text-primary" style={{ fontFamily: 'Panton' }}>
          One eSIM for Home & Away
        </h2>
        <p className="text-center text-secondary mb-12 max-w-2xl mx-auto">
          Your Jetogo eSIM works seamlessly whether you're at home or traveling abroad
        </p>

        {/* Two Row Layout */}
        <div className="max-w-6xl mx-auto space-y-16 lg:space-y-24">

          {/* Row 1: Use at Home - Text Left, Image Right */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Text Content */}
            <div className="order-2 md:order-1">
              <div className="flex items-center gap-3 mb-6">
                <HiOutlineHome className="w-8 h-8 text-[#49a078]" />
                <h3
                  className="text-2xl lg:text-3xl font-bold text-[#49a078]"
                  style={{ fontFamily: 'Panton' }}
                >
                  Use at Home
                </h3>
              </div>
              <ul className="space-y-4">
                {homeFeatures.map((item, index) => (
                  <li key={index} className="flex items-center gap-4">
                    <img
                      src={item.icon}
                      alt=""
                      width="32"
                      height="32"
                      className="w-8 h-8 flex-shrink-0 dark:brightness-125"
                      loading="lazy"
                      decoding="async"
                      style={{ filter: 'invert(47%) sepia(52%) saturate(419%) hue-rotate(107deg) brightness(94%) contrast(89%)' }}
                    />
                    <span className="text-gray-700 dark:text-gray-300 text-base lg:text-lg">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Image with decorative rectangle - TOP RIGHT */}
            <div className="order-1 md:order-2 relative flex justify-center pr-6 pt-6">
              {/* Decorative rectangle - top-right, horizontal orientation */}
              <div
                className="absolute top-0 right-0 w-3/5 h-2/5 rounded-2xl"
                style={{ backgroundColor: tealColor }}
              />
              {/* Main image */}
              <div className="relative w-full max-w-md aspect-square overflow-hidden rounded-2xl shadow-lg">
                <img
                  src="/assets/images/slider/on_trip.png"
                  alt="Use at Home"
                  width="448"
                  height="448"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>
          </div>

          {/* Row 2: Use When Away - Image Left, Text Right */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Image with decorative rectangle - BOTTOM LEFT */}
            <div className="relative flex justify-center pl-6 pb-6">
              {/* Decorative rectangle - bottom-left, vertical orientation */}
              <div
                className="absolute bottom-0 left-0 w-2/5 h-3/5 rounded-2xl"
                style={{ backgroundColor: tealColor }}
              />
              {/* Main image */}
              <div className="relative w-full max-w-md aspect-square overflow-hidden rounded-2xl shadow-lg">
                <img
                  src="/assets/images/slider/at_home.png"
                  alt="Use When Away"
                  width="448"
                  height="448"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
            </div>

            {/* Text Content */}
            <div>
              <div className="flex items-center gap-3 mb-6">
                <MdFlight className="w-8 h-8 text-[#49a078]" />
                <h3
                  className="text-2xl lg:text-3xl font-bold text-[#49a078]"
                  style={{ fontFamily: 'Panton' }}
                >
                  Use When Away
                </h3>
              </div>
              <ul className="space-y-4">
                {awayFeatures.map((item, index) => (
                  <li key={index} className="flex items-center gap-4">
                    <img
                      src={item.icon}
                      alt=""
                      width="32"
                      height="32"
                      className="w-8 h-8 flex-shrink-0 dark:brightness-125"
                      loading="lazy"
                      decoding="async"
                      style={{ filter: 'invert(47%) sepia(52%) saturate(419%) hue-rotate(107deg) brightness(94%) contrast(89%)' }}
                    />
                    <span className="text-gray-700 dark:text-gray-300 text-base lg:text-lg">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeAwayRevealSection;
